module.exports = __webpack_public_path__ + "img/avatar.75f33ff3.png";